module.exports = __webpack_public_path__ + "static/missing-texture-7678d38bd9857a2ac8e62ee458c8cc98.png";